export const CAROUSEL_LOADING = 100
export const DOT_WIDTH = 8
